// extracted by mini-css-extract-plugin
export var orderDetails = "_p4-2";
export var orderImage = "_p4-1";
export var orderMeta = "_p4-3";
export var orderSummary = "_p4-0";
export var rightArrow = "_p4-4";